<template>
  <b-card>
    <div class="flex mb-2 gap-3 items-center">
      <b-img
        class="cursor-pointer mt-[-0.5rem]"
        src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
        alt=""
        @click="$router.back()"
      />
      <h4>
        <strong class="text-black text-2xl">Komchat Coin History</strong>
      </h4>
    </div>
    <div class="mt-2 grid md:flex gap-2 items-center justify-end">
      <date-range-picker
        ref="picker"
        v-model="dateRange"
        :locale-data="locale"
        :ranges="ranges"
        :opens="'left'"
        class=" mr-1"
      >
        <template
          v-slot:input="picker"
          style="min-width: 350px"
        >
          <div
            class="d-flex justify-content-between align-items-center"
          >
            <span
              class="mr-2"
            >{{ DDMMYYYY(picker.startDate) }} -
              {{ DDMMYYYY(picker.endDate) }}</span>
            <img
              src="https://storage.googleapis.com/komerce/assets/icons/date-picker-icon.svg"
              alt=""
            >
          </div>
        </template>
      </date-range-picker>
      <BDropdown
        id="dropdown-1"
        right
        class="filter"
        no-caret
        variant="primary"
        toggle-class="text-decoration-none toggle-custom button-primary rounded-lg !py-[5px] px-1"
      >
        <h5 class="pl-[21px]">
          Filter
        </h5>
        <template #button-content>
          <b-img
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/filter-search.svg"
            class="height-[20px]"
          />
        </template>
        <BDropdown
          id="dropdown-2"
          class="w-100"
          toggle-class="text-left"
          variant="none"
          left
          no-caret
          dropright
        >
          <template #button-content>
            <span class="hover-salmon text-6">Jenis Produk</span>
          </template>
          <b-dropdown-item @click="applyFilter('productType', 'komchat_ai')">
            Komchat AI
          </b-dropdown-item>
          <b-dropdown-item @click="applyFilter('productType', 'komchat_for_brand')">
            Komchat for Brands
          </b-dropdown-item>
        </BDropdown>
        <BDropdown
          id="dropdown-2"
          class="w-100"
          toggle-class="text-left"
          variant="none"
          left
          no-caret
          dropright
        >
          <template #button-content>
            <span class="hover-salmon text-6">Transaksi</span>
          </template>
          <b-dropdown-item
            @click="applyFilter('transaction', 'credit')"
          >
            <span class="text-[#0EAD69]"> Masuk</span>
          </b-dropdown-item>
          <b-dropdown-item
            @click="applyFilter('transaction', 'debit')"
          >
            <span class="text-primary">Keluar</span>
          </b-dropdown-item>
        </BDropdown>
        <!-- <BDropdown
          id="dropdown-2"
          class="w-100"
          toggle-class="text-left"
          variant="none"
          left
          no-caret
          dropright
        >
          <template #button-content>
            <span class="hover-salmon text-6">Tanggal</span>
          </template>

        </BDropdown> -->
        <h5
          class="pb-0 pt-1 font-bold text-danger w-100 cursor-pointer"
          style="padding-left: 21px;"
          @click="resetFilter()"
        >
          Reset filter
        </h5>
      </BDropdown>
    </div>
    <b-row>
      <b-col>
        <b-overlay
          spinner-variant="primary"
          variant="light"
          blur="0"
          opacity=".5"
          rounded="sm"
          :show="isLoading"
        >
          <BTable
            :items="items"
            :fields="fieldsKomchatCoinstable"
            show-empty
            empty-text="Belum ada history penggunaan Komchat Coin!"
            responsive
            sticky-header="500px"
            class="mt-1"
            @scroll.native="handleScroll"
          >
            <template #cell(date_payment)="data">
              <div class="text-black text-capitalize">
                {{ DDMMYYYY(data.item.date_payment) }}
              </div>
              <span class="text-sm text-[#7B7B7B]">{{ data.item.date_payment.split('T')[1].split('.')[0] }}</span>
            </template>
            <template #cell(description)="data">
              <div class="text-black flex gap-1 text-capitalize">
                {{ data.item.transaction_type }} <img
                  v-show="data.item.transaction_type === 'Komchat for Brands'"
                  src="https://storage.googleapis.com/komerce/assets/icons/verified.svg"
                  alt=""
                >
              </div>
              <span class="text-sm text-[#7B7B7B]">  {{ data.item.description }}</span>
            </template>
            <template #cell(amount)="data">
              <div
                :class="data.item.amount.includes('+')? 'text-[#0EAD69]': 'text-primary'"
                class="text-capitalize"
              >
                {{ data.item.amount }}
              </div>
            </template>
          </BTable>
        </b-overlay></b-col>
    </b-row>

  </b-card>
</template>
<script>
import { DDMMYYYY, YYYYMMDD } from '@/libs/formatDate' // Asumsi ada helper YYYYMMDD
import DateRangePicker from 'vue2-daterange-picker'
import { apiGetBalanceHistory } from './Broadcast/service/api.balance.service'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
// eslint-disable-next-line import/order
import {
  today,
  last7,
  last30,
  firstDateOfMonth,
  // lastDateOfMonth, // Tidak terpakai
} from '@/store/helpers'
import { fieldsKomchatCoinstable } from './Broadcast/config'

export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      fieldsKomchatCoinstable,
      items: [],
      isLoading: false,
      isDropdown2Visible: false, // Ini untuk logika dropdown, biarkan saja
      // MODIFIKASI: Inisialisasi dateRange agar picker menampilkan tanggal awal
      dateRange: {
        startDate: last30,
        endDate: today,
      },
      DDMMYYYY,
      filter: {
        offset: 0,
        limit: 10,
        startDate: null, // Akan diisi oleh watcher
        endDate: null, // Akan diisi oleh watcher
        productType: '',
        transaction: '',
        // MODIFIKASI: Flag untuk mendeteksi data terakhir
        isLastData: false,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'],
      },
      ranges: {
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Bulan Ini': [firstDateOfMonth, today],
      },
      // Hapus data yang tidak perlu karena sudah di-return dari data()
      // today, last7, dst.
    }
  },
  // NEW: Tambahkan watcher untuk memantau perubahan filter tanggal
  watch: {
    dateRange: {
      handler(newVal) {
        if (newVal.startDate && newVal.endDate) {
          // Asumsi API butuh format YYYY-MM-DD
          this.filter.startDate = YYYYMMDD(newVal.startDate)
          this.filter.endDate = YYYYMMDD(newVal.endDate)
          // Saat tanggal berubah, reset list dan fetch dari awal
          this.resetAndFetch()
        }
      },
      deep: true, // Diperlukan untuk memantau perubahan object
    },
  },
  mounted() {
    // Inisialisasi tanggal saat komponen pertama kali dimuat
    this.filter.startDate = YYYYMMDD(this.dateRange.startDate)
    this.filter.endDate = YYYYMMDD(this.dateRange.endDate)
    this.getListData()

    // Logika dropdown biarkan saja
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2' || bvEvent.componentId === 'dropdown-3' || bvEvent.componentId === 'dropdown-4') {
        this.isDropdown2Visible = true
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if (bvEvent.componentId === 'dropdown-2' || bvEvent.componentId === 'dropdown-3' || bvEvent.componentId === 'dropdown-4') {
        this.isDropdown2Visible = false
      }
      if (this.isDropdown2Visible) {
        bvEvent.preventDefault()
      }
    })
  },
  methods: {
    async getListData() {
      // MODIFIKASI: Jangan fetch jika sedang loading atau sudah data terakhir
      if (this.isLoading || this.filter.isLastData) return

      this.isLoading = true
      const params = {
        offset: this.filter.offset,
        limit: this.filter.limit,
        start_date: this.filter.startDate,
        end_date: this.filter.endDate,
        product_type: this.filter.productType,
        transaction: this.filter.transaction,
      }
      try {
        const response = await apiGetBalanceHistory(params)
        const newData = response.data.data

        if (newData && newData.length > 0) {
          // MODIFIKASI: Tambahkan data baru, jangan timpa data lama (untuk infinite scroll)
          this.items = [...this.items, ...newData]
          this.filter.offset += this.filter.limit
        }

        // MODIFIKASI: Deteksi data terakhir
        // Jika data yang diterima lebih sedikit dari limit, berarti ini halaman terakhir
        if (!newData || newData.length < this.filter.limit) {
          this.filter.isLastData = true
        }
      } catch (error) {
        console.error(error)
        // Mungkin bisa tambahkan notifikasi error di sini
      } finally {
        this.isLoading = false
      }
    },

    // NEW: Method untuk menerapkan filter dari dropdown
    applyFilter(type, value) {
      this.filter[type] = value
      this.resetAndFetch()
    },

    // MODIFIKASI: Sempurnakan fungsi resetFilter
    resetFilter() {
      // Reset state filter
      this.filter.productType = ''
      this.filter.transaction = ''

      // Reset date picker ke 30 hari terakhir (watcher akan otomatis trigger resetAndFetch)
      this.dateRange = {
        startDate: last30,
        endDate: today,
      }
    },

    // NEW: Helper untuk mereset list sebelum fetch data baru (saat filter berubah)
    resetAndFetch() {
      this.items = []
      this.filter.offset = 0
      this.filter.isLastData = false
      this.getListData()
    },

    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      // Tambahkan buffer kecil (misal 5px) agar trigger sebelum benar-benar di bawah
      if (scrollTop + clientHeight >= scrollHeight - 5) {
        this.getListData()
      }
    },
  },
}
</script>
